import React, { useEffect } from 'react';

import styled from 'styled-components';

import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { XSS_FILTER_OPTIONS } from 'apps/auth/constants/Constants';
import { filterXSS } from 'xss';

const BanksListWrap = styled.div`
    margin: ${(props) => (props.marginNegative ? '0 -36px' : '')};
`;
const BanksList = styled.div`
    position: fixed;
    top: 128px;
    height: calc(100% - 144px);
    width: ${(props) => (props.marginNegative ? 'calc(100% + 36px)' : 'calc(100% - 48px)')};
    max-width: 504px;
`;

const IframeModal = (props) => {
    useEffect(() => {
        if (props.addEventListener) {
            window.addEventListener('message', props.detectFLinkSteps, false);
            return () => {
                window.removeEventListener('message', props.detectFLinkSteps);
            };
        }
    }, []);

    const renderContent = () => {
        if (props.iframeTag) {
            const iframe = props.iframeTag.replace('iframe ', 'iframe style="width: 100%; height: 100%; border: none;" ');
            return <BanksList marginNegative={props.marginNegative} dangerouslySetInnerHTML={{ __html: filterXSS(iframe, XSS_FILTER_OPTIONS) }} />;
        } else {
            return (
                <BanksList marginNegative={props.marginNegative}>
                    <iframe src={props.iframeLink} style={{ width: '100%', height: '100%', border: 'none' }} title={''} />
                </BanksList>
            );
        }
    };

    return (
        <ModalComponent modalRef={props.modalRef}>
            <BanksListWrap marginNegative={props.marginNegative}>{renderContent()}</BanksListWrap>
        </ModalComponent>
    );
};

export default IframeModal;
